<template>
  <div class="background-03">
    <v-layout row wrap>
      <v-flex xs12 sm2 md2 class="hidden-xs-only">
        <image-app class="animated fadeInLeft" :imaSize="300" imaSrc="design/banco1-1-3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="Administración del dinero" titleLevel="h1">
          <template slot="partOne">Administración<br></template>
          <template slot="partTwo">del </template>
          <template slot="partThree"> dinero</template>
        </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'Administración del dinero'" videoEmbed="ADMINISTRACIONDINERO03AdministracionDelDinero.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box">Administrar el dinero no significa crear un presupuesto estricto y renunciar a los gustos espontáneos. Significa tomar decisiones conscientes al momento de gastar el dinero, lo que puede ayudarle a reducir deudas y a acumular ahorros para usarlos en el futuro y cumplir las <strong>metas.</strong>
          <audio-player ref="audioPlayer" :audios="[
            'Administracion1.mp3'
            ]"></audio-player>
        </p>
      </v-flex>
      <v-flex xs12 md6 class="text-xs-center">
        <image-app :imaSize="230" imaSrc="contenido/personaje_1" imaAlt="Mujer explicando el concepto"></image-app>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
    setTimeout(()=>{this.$refs.audioPlayer.playAudio(0)},1000);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-03.vue?6da50a64